import type { UserRole } from '~/prisma/enums'
import type { OfferType } from '~/types'

type PositionInputPermission = 'action-buttons' | 'move-position' | 'delete-position' | 'position-fields' | 'pdfs'
const serviceProjectPositionPermissions: Record<PositionInputPermission, UserRole[]> = {
  'action-buttons': ['admin', 'rentalEmployee', 'departmentLead', 'projectManager', 'serviceProjectEmployee', 'siteManager'],
  'move-position': ['admin', 'rentalEmployee', 'departmentLead', 'projectManager', 'serviceProjectEmployee', 'siteManager'],
  'delete-position': ['admin', 'rentalEmployee', 'departmentLead', 'projectManager', 'serviceProjectEmployee', 'siteManager'],
  'position-fields': ['admin', 'rentalEmployee', 'departmentLead', 'projectManager', 'serviceProjectEmployee', 'siteManager'],
  'pdfs': ['admin', 'rentalEmployee', 'departmentLead', 'projectManager', 'serviceProjectEmployee', 'siteManager'],
}

export function usePositionInputPermissions() {
  const { hasAnyAssignedRole } = useAuthorization()
  function hasPositionPermission(permission: PositionInputPermission, offerType?: OfferType): Ref<boolean> {
    if (!offerType || offerType !== 'service-project') {
      return computed(() => true)
    }
    return hasAnyAssignedRole(serviceProjectPositionPermissions[permission])
  }
  return { hasPositionPermission }
}
